import { object } from '@iwentsourcing/core/typing/object.js';
import { string } from '@iwentsourcing/core/typing/string.js';
import { InstanceType } from '@iwentsourcing/core/management/instance-type.js';
import { StreamArgs } from './stream-args.js';
import { optional } from '@iwentsourcing/core/typing/optional.js';
import { record } from '@iwentsourcing/core/typing/record.js';
import { StateValue } from '@iwentsourcing/core/storage/state-value.js';

export const StateGet = object('StateGet', {
  realm: string(),
  tenant: string(),
  version: string(),
  pattern: string(),
  type: InstanceType,
  args: StreamArgs,
  state: string(),

  id: record(string(), StateValue),

  token: optional(string()),
});
